const sidebarReducer = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR':
      return action.enabled
    default:
      return state
  }
}

export default sidebarReducer



/** WEBPACK FOOTER **
 ** ./src/reducers/sidebarReducer.js
 **/